module.exports = __webpack_public_path__ + "img/head_touji.53b129c8.png";